import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'

function ModelStatus({
  status, icon, statusType = '', id, expiresAt = '',
}) {
  const statusTooltip = {
    'rejected:copyright': 'suspended.copyright',
    'rejected:adult': 'suspended.adult',
    'rejected:reported': 'suspended.reported',
    'rejected:copyright:pending': 'pending.copyright',
    'rejected:adult:pending': 'pending.adult',
  }

  const statusTooltipMessage = I18n.t(`profile.my_products.status_tooltips.${statusTooltip[statusType]}`)

  function renderStatus() {
    return (
      <Fragment>
        <Icon type={['far', icon]} />{status}
        {expiresAt && (
          <div className="text-light-grey text-extra-small">
            <i>(expires {moment(expiresAt).fromNow()})</i>
          </div>
        )}
      </Fragment>
    )
  }

  if (status === 'Pending') {
    return (
      <div>
        <Tooltip
          id={`status-tooltip-${id}`}
          tooltipClassName="tooltip--big"
          content="Your model is under review and will be processed within 3 to 5 business days. Please refrain from
           contacting support until this time has passed. Thank you for your patience!"
        >
          {renderStatus()}
        </Tooltip>
      </div>
    )
  }

  return (
    <div>
      {statusType !== '' && statusTooltip[statusType] ? (
        <Tooltip
          id={`status-tooltip-${id}`}
          tooltipClassName="tooltip--big"
          content={statusTooltipMessage}
        >
          {renderStatus()}
        </Tooltip>
      ) : (
        <div>{renderStatus()}</div>
      )}
    </div>
  )
}

ModelStatus.propTypes = {
  status: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  statusType: PropTypes.string,
  id: PropTypes.string.isRequired,
  expiresAt: PropTypes.string,
}

export default ModelStatus
